// extracted by mini-css-extract-plugin
export default {"container":"Qq-z","heading":"Rq-z","text":"Sq-z","info":"Tq-z","link":"Uq-z","fullMaxWidth":"Vq-z"};